"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const index_1 = require("../../index");
const DisksTable_1 = require("./DisksTable");
const SectionTitle_1 = tslib_1.__importDefault(require("../ui/SectionTitle"));
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const StorageDetail = ({ host, canEditDisks, onDiskRole, updateDiskSkipFormatting, }) => {
    const inventory = (0, index_1.getInventory)(host);
    const disks = inventory.disks || [];
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(react_core_1.Grid, { hasGutter: true },
        react_1.default.createElement(SectionTitle_1.default, { testId: 'disks-section', title: t('ai:{{count}} Disk', { count: disks.length }) }),
        react_1.default.createElement(react_core_1.GridItem, null,
            react_1.default.createElement(DisksTable_1.DisksTable, { testId: 'disks-table', canEditDisks: canEditDisks, host: host, disks: disks, installationDiskId: host.installationDiskId, onDiskRole: onDiskRole, updateDiskSkipFormatting: updateDiskSkipFormatting }))));
};
exports.default = StorageDetail;
//# sourceMappingURL=StorageDetail.js.map